var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitgetWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1899_77)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 40,
    fill: "#54FFF5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1899_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9614 397.206C-58.6549 638.082 399.323 570.05 639.014 505.924C884.329 424.513 714.773 65.6498 538.83 57.7076C362.887 49.7654 560.645 223.645 411.191 273.307C261.737 322.97 133.982 96.1127 26.9614 397.206Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1899_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.024 -91.647C126.112 -214.354 -33.8378 -47.9926 -108.199 50.5266C-179.13 157.694 6.01875 250.302 78.6417 200.073C151.265 149.844 15.549 140.071 58.7416 74.7551C101.934 9.43956 227.163 61.7371 171.024 -91.647Z",
    fill: "#00FFF0",
    fillOpacity: 0.67
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1899_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.959 450.845C131.701 244.725 -132.163 353.272 -256.438 433.312C-375.98 528.082 -92.1419 800.694 25.7453 786.749C143.632 772.804 -68.8233 654.128 3.97428 596.339C76.7719 538.549 269.533 708.496 192.959 450.845Z",
    fill: "#9D81FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1899_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.24 -214.706C432.094 -372.062 242.925 -241.94 164.859 -157.209C96.5476 -61.2893 448.549 114.462 546.243 84.3427C643.936 54.2231 413.023 -8.10076 454.594 -66.5759C496.164 -125.051 729.423 -18.0113 564.24 -214.706Z",
    fill: "#4D94FF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.378 305.672H273.347L174.417 206.102L274.619 106.533L301.911 80H211.639L96.672 195.555C90.8701 201.379 90.8999 210.803 96.7315 216.598L186.378 305.672ZM238.66 206.336H237.991L238.653 206.329L238.66 206.336ZM238.66 206.336L337.583 305.898L237.381 405.468L210.089 432.001H300.361L415.328 316.453C421.13 310.629 421.1 301.205 415.269 295.41L325.622 206.336H238.66Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1899_77",
    x: -180.482,
    y: -139.48,
    width: 1139.12,
    height: 902.864,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 98.4615,
    result: "effect1_foregroundBlur_1899_77"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1899_77",
    x: -321.021,
    y: -331.978,
    width: 703.193,
    height: 743.016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 98.4615,
    result: "effect1_foregroundBlur_1899_77"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1899_77",
    x: -482.155,
    y: 135.284,
    width: 889.703,
    height: 848.905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 98.4615,
    result: "effect1_foregroundBlur_1899_77"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1899_77",
    x: -40.7937,
    y: -485.519,
    width: 860.381,
    height: 770.211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 98.4615,
    result: "effect1_foregroundBlur_1899_77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1899_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitgetWalletIcon);
export default __webpack_public_path__ + "static/media/bitget-wallet-icon.373cc9a6598c4f6001056ddae06c885e.svg";
export { ForwardRef as ReactComponent };